/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.0.0
 */

/*
* -------------------------------------------
*          LOAD INQUIRY USER
* -------------------------------------------
*/

export const MODAL_INQUIRY_LOAD_USER = '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_USER';

export const MODAL_INQUIRY_LOAD_USER_SUCCESSFUL =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_USER_SUCCESSFUL';

export const MODAL_INQUIRY_LOAD_USER_FAILED =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_USER_FAILED';



/*
* -------------------------------------------
*          LOAD TOPIC LIST
* -------------------------------------------
*/

export const MODAL_INQUIRY_LOAD_TOPIC_LIST = '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_TOPIC_LIST';

export const MODAL_INQUIRY_LOAD_TOPIC_LIST_SUCCESSFUL =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_TOPIC_LIST_SUCCESSFUL';

export const MODAL_INQUIRY_LOAD_TOPIC_LIST_FAILED =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_TOPIC_LIST_FAILED';


/*
* -------------------------------------------
*          LOAD TOPIC INFO
* -------------------------------------------
*/

export const MODAL_INQUIRY_LOAD_TOPIC =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_TOPIC';

export const MODAL_INQUIRY_LOAD_TOPIC_SUCCESSFUL =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_TOPIC_SUCCESSFUL';

export const MODAL_INQUIRY_LOAD_TOPIC_FAILED =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_LOAD_TOPIC_FAILED';


/*
* -------------------------------------------
*          CREATE INQUIRY
* -------------------------------------------
*/

export const MODAL_INQUIRY_CREATE =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_CREATE';

export const MODAL_INQUIRY_CREATE_SUCCESSFUL =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_CREATE_SUCCESSFUL';

export const MODAL_INQUIRY_CREATE_FAILED =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_CREATE_FAILED';


/*
* -------------------------------------------
*          CLOSE INQUIRY
* -------------------------------------------
*/

export const MODAL_INQUIRY_CLOSE =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_CLOSE';


/*
* -------------------------------------------
*          INQUIRY ATTACH FILE
* -------------------------------------------
*/

export const MODAL_INQUIRY_ATTACH_FILE =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_ATTACH_FILE';

export const MODAL_INQUIRY_ATTACH_FILE_SUCCESSFUL =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_ATTACH_FILE_SUCCESSFUL';

export const MODAL_INQUIRY_ATTACH_FILE_FAILED =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_ATTACH_FILE_FAILED';


/*
* -------------------------------------------
*          INQUIRY DETACH FILE
* -------------------------------------------
*/

export const MODAL_INQUIRY_DETACH_FILE =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_DETACH_FILE';

export const MODAL_INQUIRY_DETACH_FILE_SUCCESSFUL =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_DETACH_FILE_SUCCESSFUL';

export const MODAL_INQUIRY_DETACH_FILE_FAILED =
    '@@b2b_portal_ui/table/modalInquiryCreate/MODAL_INQUIRY_DETACH_FILE_FAILED';
